import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

/**
 *
 * @public
 */
export interface GithubActionsApi {
  ListWorkflowRuns(name: string): Promise<PipelineRun[]>;
}

/**
 *
 * @public
 */
export interface PipelineRun {
  id: number;
  workflow_name: string;
  timestamp: string;
  latest_change: string;
  triggered_by: string;
  link: string;
  description: string;
  branch: string;
  status: string;
  html_url: string;
}

/**
 *
 * @public
 */
export const GithubActionsApiRef: ApiRef<GithubActionsApi> =
  createApiRef<GithubActionsApi>({
    id: 'plugin.github-actions.service',
  });
